import { ToastrService } from 'ngx-toastr';
import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { InterfaceService } from './../../../services/interface-service';
import { InterfaceSageDTO } from './../../../dtos/interface-sage-dto';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';

export interface DialogData {
  icone: string;
  title: string;
  subTitle: string;
  message: string;
  color: string;
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  result: boolean;
}

@Component({
  selector: 'app-generate-file-interface-modal',
  templateUrl: './generate-file-interface-modal.component.html',
  styleUrls: ['./generate-file-interface-modal.component.scss']
})
export class GenerateFileInterfaceModalComponent implements OnInit {

  icone: string;
  title: string;
  subTitle: string;
  message: string;
  color: string;
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  societyList: SocieteModel[];
  societyInputList: string[] = [];
  form: UntypedFormGroup;
  disabled = true;
  currentSociety: SocieteModel;
  @Input() idSociety: number;
  interfaceSage: InterfaceSageDTO = new InterfaceSageDTO();
  listUpdated = new BehaviorSubject<string[]>(this.societyInputList);

  constructor(public dialog: MatDialog,
              private societyService: SocieteService,
              public router: Router,
              public interfaceService: InterfaceService,
              public dialogRef: MatDialogRef<Component>,
              public toastr: ToastrService,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.form = this.getFormGroup();
  }

  onSocietyChange(event): void {
    const tempSelectedList = this.societyList.filter(item => event.indexOf(item.code + '-' + item.libelle) > -1);
    this.form.controls.societyList.setValue([...tempSelectedList.map(item => item.id)]);
  }


  ngOnInit(): void {
    this.icone = this.data.icone !== undefined ? this.data.icone : '';
    this.title = this.data.title !== undefined ? this.data.title : '';
    this.subTitle = this.data.subTitle !== undefined ? this.data.subTitle : '';
    this.icon_color = this.data.icon_color !== undefined ? this.data.icon_color : '';
    this.dialogWidth = this.data.dialogWidth !== undefined ? this.data.dialogWidth : '';
    this.dialogHeight = this.data.dialogHeight !== undefined ? this.data.dialogHeight : '';
    this.color = this.data.color;
    this.societyService.getAllForInterfaceSage().subscribe(obj => {
      this.societyList = obj;
      this.societyInputList = [...this.societyList.map(item => item.code + '-' + item.libelle)];
      this.societyInputList = [...this.societyList.map(item => item.code + '-' + item.libelle)];
      this.listUpdated.next(this.societyInputList);
      var date = new Date(Date.now());

      date.setFullYear(date.getFullYear() + 1);
      this.form.controls.endDate.setValue(date);

      this.form.controls.societyList.setValue([...this.societyList.map(item => item.id)]);

    });
  }
  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.get('startDate').value > this.form.get('endDate').value) {
      this.form.get('endDate').setErrors({
        inferieur: true
      });
    }
    if (this.form.valid) {
      this.interfaceSage = this.form.getRawValue();
      const spinnerDiag = this.dialog.open(SpinnerModalComponent);
      this.interfaceService.generateFile(this.interfaceSage).subscribe((resGenFile: boolean) => {
          spinnerDiag.close();
          if (resGenFile) {
            this.toastr.success('Les fichiers OD, FACT et BAP sont bien générés');
            this.dialogRef.close(true);
          } else {
            this.toastr.error('Erreur lors de la génération des fichiers OD, FACT et BAP');
          }
      }, () => spinnerDiag.close());
    }
    this.data.result = true;
  }

  getFormGroup(): UntypedFormGroup {
    const form = new UntypedFormGroup({
      societyList: new UntypedFormControl('', Validators.required),
      startDate: new UntypedFormControl('', Validators.required),
      endDate: new UntypedFormControl('', [Validators.required]),
      periode: new UntypedFormControl('', [Validators.required , Validators.pattern('(20[0-9]{2}-(0[1-9]|10|11|12))$')]),
    });
    return form;
  }
}
